import type React from 'react'
import type { JSX } from 'react'
import type { ICard } from '../Card'

import { FallbackImageSizes } from 'atoms/FallbackImage'
import { IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { Card } from '../Card'
import {
  CARDS_ASPECT_RATIO,
  CardAnimations,
  CardCorners,
  CardPosterSize,
} from '../Card.h'
import { TVCardHoverContent } from './TVCardHoverContent'
import { useTvCardHoverHandlers } from './useTvCardHoverHandlers'

export interface ITVCardDefaultProps extends Omit<ICard, 'children'> {
  children: React.ReactNode
  backgroundColorSelected: COLOR
}

export const TVCardDefault = ({
  children,
  posterUrl = '',
  width = '100%',
  aspectRatio = CARDS_ASPECT_RATIO.SQUARE,
  posterWidth = CardPosterSize.TvPosterWidthDefault,
  posterHeight = CardPosterSize.TvPosterHeightDefault,
  corners = CardCorners.CORNERS_0,
  backgroundColor = COLOR.BASE_MAIN_DEFAULT,
  backgroundColorSelected = COLOR.BASE_MAIN_DEFAULT,
  backgroundColorHovered = COLOR.BASE_MAIN_DEFAULT,
  childrenTransition = CardAnimations.FadeIn,
  viewedButtonFavorite = true,
  fallbackImageSize = FallbackImageSizes.S,
  fallbackImageBackground = COLOR.TRANSPARENT,
  selected,
  lockedSizeIcon = IconSizes.xLarge,
  aclBlockedBy = false,
  ...rest
}: ITVCardDefaultProps): JSX.Element => {
  const { hoverContentVisible, cardRest, onMouseEnter, onMouseLeave } =
    useTvCardHoverHandlers(rest)

  return (
    <Card
      posterUrl={posterUrl}
      width={width}
      aspectRatio={aspectRatio}
      posterWidth={posterWidth}
      posterHeight={posterHeight}
      corners={corners}
      backgroundColor={selected ? backgroundColorSelected : backgroundColor}
      backgroundColorHovered={backgroundColorHovered}
      childrenTransition={undefined}
      {...cardRest}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      fallbackImageSize={fallbackImageSize}
      fallbackImageBackground={fallbackImageBackground}
      selected={selected}
      lockedSizeIcon={lockedSizeIcon}
      aclBlockedBy={aclBlockedBy}
    >
      <TVCardHoverContent
        favoriteChildren={children}
        hoverContent={<></>}
        viewedButtonFavorite={viewedButtonFavorite}
        aclBlockedBy={aclBlockedBy}
        childrenTransition={childrenTransition}
        hoverTrigger={hoverContentVisible}
      />
    </Card>
  )
}
